// Package imports:
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { DayPicker, DateRange } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay } from '@fortawesome/pro-light-svg-icons';
// Style imports:
// import './DatePickerRange.scss';
// Component imports:
import Button from 'react-bootstrap/Button';
// Service imports:
import { turnDateToSimpleTime } from '../../services/utils';
// Action imports:
import { setDayRange } from '../../redux-store/actions/dashboardActions';
// Type imports:
import { RootState } from '../../redux-store/reducers';

type ReduxProps = ConnectedProps<typeof connector>
type Props = ReduxProps;

interface IState {
    isDatePickerFocused: boolean,
    fromDate: string,
    toDate: string
};

class DatePickerRange extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isDatePickerFocused: false,
            fromDate: this.props.fromDate,
            toDate: this.props.toDate,
        };
    }

    handleRangeChange = (range: DateRange | undefined) => {
        this.setState({
            fromDate: range?.from ? turnDateToSimpleTime(range.from) : '',
            toDate: range?.to ? turnDateToSimpleTime(range.to) : ''
        });
    };

    handleSetRange = () => {
        const { fromDate, toDate } = this.state;
        const formattedFromDate = turnDateToSimpleTime(new Date(fromDate || Date.now()));
        const formattedToDate = turnDateToSimpleTime(new Date(toDate || Date.now()));
        this.props.setDayRange(formattedFromDate, formattedToDate);
    };

    render () {
        const { fromDate, toDate, isDatePickerFocused } = this.state;
        const formattedFromDate = fromDate ? new Date(fromDate).toLocaleDateString('en-GB') : '';
        const formattedToDate = toDate ? new Date(toDate).toLocaleDateString('en-GB') : '';
        return (
            <div id='DatePickerRange'>
                <h5>Dates:</h5>
                <div className='DatePickerContainer'>
                    {!isDatePickerFocused && (
                    <span className="SelectedDateRange">
                        {formattedFromDate} {formattedFromDate && formattedToDate ? ' - ' : ''} {formattedToDate}
                    </span>
                    )}
                    {isDatePickerFocused && (
                        <DayPicker
                            mode='range'
                            selected={{ 
                                from: fromDate ? new Date(fromDate) : undefined, 
                                to: toDate ? new Date(toDate) : undefined 
                            }}
                            onSelect={this.handleRangeChange}
                            disabled={[
                                (date: Date) => [0, 6].includes(date.getDay()), // Disable weekends
                                { after: new Date() } // Disable future dates
                            ]}
                        />
                    )}
                    <FontAwesomeIcon
                        icon={faCalendarDay}
                        className='CalendarIcon'
                        onClick={() => this.setState({ isDatePickerFocused: !isDatePickerFocused })}
                    />
                </div>
                <Button
                    size='sm'
                    variant='dark'
                    className='DatePickerButton'
                    onClick={() => {
                        this.props.setDayRange(this.state.fromDate, this.state.toDate);
                        this.setState({ isDatePickerFocused: false });
                    }}
                >
                    Set
                </Button>
            </div>
        );
    }
}

function mapStateToProps({ dashboardReducer }: RootState) {
    const { dayRange } = dashboardReducer;
    const { fromDate, toDate } = dayRange;
    return {
        fromDate,
        toDate
    };
}

const connector = connect(mapStateToProps, { setDayRange });
export default connector(DatePickerRange);
